import React from "react"
import { graphql } from "gatsby"
// import Image from "gatsby-image"
import Layout from "../components/layout"
import SEO from "../components/seo"
import BreadCrumbs from "../components/breadcrumbs"
import ProductImage from "../components/product-image"
import ProductWeights from "../components/product_weights"
import AnalyticalConstituents from "../components/analytical_constituents"
import ProductRecipes from "../components/product_more_recipes"

export const query = graphql`
    query($item_code: String!) {
        almoProductsJson(item_code: {eq: $item_code}) {
            item_code
            item_description
            description
            page_image_main
            family_product
            animal
            brand_name_new
            segment_range_new
            analytical_constituents_title
            analytical_constituents {
              value
              title
            }
            composition_title
            ingredients_title
            composition
            calories
            energy_title
            recipe
            recipes {
              recipe
              item_code
              weight {
                card_image_main
              }
            }
            weight {
              weight_uom
              weight
              package_type_icon
            }
          }
    }
`

const almoProductsPage = ({ data }) => {
    const product = data.almoProductsJson
    const seoTitle = product.brand_name_new + ' ' + product.segment_range_new
    return (
      <Layout>
        <SEO title={ seoTitle } description={ product.item_description } />
        <div className="container product">
          <BreadCrumbs 
            animal={product.animal} 
            brand={product.brand_name_new} 
            family={product.family_product}
            recipe={product.recipe} >
          </BreadCrumbs>

          <span className="promo-banner">
            Promo banner. 10% discount till August 1. 
            <a href="https://www.almonature.com/it/" target="_blank" rel="noreferrer">Get discount!</a>
          </span>

          <div className="row py-0">
            <div className="col-md-4 pt-10 product--image">
              <ProductImage product={product} />
            </div>
            <div className="col-md-8 pt-10">

                <h1 className="almo-fs-42 mb-0 product--title font-weight-bold">
                  { product.brand_name_new } { product.segment_range_new }
                </h1>

                <p className="almo-fs-24 mb-0">
                { product.recipe }
                </p>

                { product.recipes && product.recipes.length && <a href="#MoreRecipes" className="almo-link">
                  Check {product.recipes.length} more recipes below  
                  <svg
                    className="ml-10"
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentcolor"
                      d="M20.684 14.23a1 1 0 10-1.368-1.46L13 18.692V3a1 1 0 10-2 0v15.692L4.684 12.77a1 1 0 10-1.368 1.46l8 7.5a1 1 0 001.368 0l8-7.5z"
                    ></path>
                  </svg>
                </a> }

                <div className="pt-10 product--features">
                  <p className="mb-5 almo-fs-13 text-gray">BEST FOR:</p>
                  <ul className="mb-5">
                    <li>Adult 1+ year</li>
                    <li>Complementary</li>
                  </ul>
                </div>

                <div className="py-10 product--weights">
                  <p className="mb-5 almo-fs-13 text-gray">SIZE:</p>

                  <ProductWeights package_weights={product.weight} />
                </div>

                <div className="product--almo-coins">
                  <p>
                    <b>+10 AlmoCoins</b> buying this item. 
                    <a className="pl-10 almo-link" href="#LearnMore"> 
                      Learn more 
                      <svg className="ml-5"
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentcolor"
                          d="M14.23 3.316a1 1 0 10-1.46 1.368L18.692 11H3a1 1 0 100 2h15.692l-5.921 6.316a1 1 0 101.458 1.368l7.5-8a1 1 0 000-1.368l-7.5-8z"
                        ></path>
                      </svg>
                      </a>
                  </p>
                </div>

                <div className="product--cta-actions py-10">
                  <a href="#Store" className="almo-btn almo-fs-16 almo-btn--red">
                    <svg className="mr-5 primary-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        fill="currentcolor"
                        d="M12 2c4.488 0 8 3.202 8 8 0 3.288-2.347 7.058-6.962 11.4l-.36.333a.998.998 0 01-1.357.002C6.47 17.252 4 13.372 4 10c0-4.798 3.512-8 8-8zm0 2c-3.423 0-6 2.35-6 6 0 2.46 1.862 5.58 5.65 9.289l.35.337.01-.008c3.79-3.636 5.761-6.72 5.971-9.183l.014-.222L18 10c0-3.65-2.577-6-6-6zm0 2a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z"
                      ></path>
                    </svg>
                    Find the nearest store
                  </a>

                  <a href="#WishList" className="almo-btn px-10 ml-10 almo-fs-16">
                    <svg className="primary-svg--icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        fill="currentcolor"
                        d="M4 9.222c0 2.73 2.377 5.78 7.04 9.308l.364.272a.998.998 0 001.193 0C17.499 15.159 20 12.023 20 9.223c0-3.013-2.065-4.741-4.641-4.373l-.22.036a5.03 5.03 0 00-3.08 1.907l-.046.062-.127-.168a4.991 4.991 0 00-3.235-1.853C6.072 4.473 4 6.21 4 9.223zm4.544-2.38c.48.095 1.11.548 1.546 1.152.131.181.314.553.55 1.116.229.55.765.908 1.36.91a1.52 1.52 0 001.391-.896c.261-.58.453-.956.575-1.13.506-.72 1.098-1.083 1.675-1.165C17.03 6.63 18 7.443 18 9.222l-.005.157c-.105 1.847-2.05 4.326-5.91 7.303l-.085.064-.084-.064C7.944 13.62 6 11.085 6 9.222c0-1.78.982-2.603 2.375-2.408l.17.028z"
                      ></path>
                    </svg>
                  </a>

                  <a href="#WishList" className="almo-btn px-10 ml-10 almo-fs-16">
                    <svg className="primary-svg--icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        fill="currentcolor"
                        d="M12 5a2 2 0 011.732 1H19a1 1 0 010 2h-.644l3.68 7.008-.036.018A4 4 0 0114 15h.039l3.672-7-3.98.001a2 2 0 01-1.582.994L12 9a2 2 0 01-1.732-.999L6.322 8l3.676 7c.002.001.002.002.002.003l.003.005A4.004 4.004 0 016 19a4 4 0 01-4-4h.006l3.671-7H5a1 1 0 110-2h5.268A2 2 0 0112 5zm6.034 5.613L15.733 15h4.605l-2.304-4.387zM6 10.613L3.699 15h4.605L6 10.613z"
                      ></path>
                    </svg>
                  </a>
                </div>


                <div className="product--share py-20">
                  <a href="https://www.twitter.com/"  target="_blank" rel="noreferrer" className="product--share--tw">
                    <svg className="mr-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        fill="currentcolor"
                        d="M14.69 6.003V6h.75l.275.05a3.124 3.124 0 01.93.316c.14.071.267.144.38.217.113.073.214.15.303.232.089.083.227.104.414.064.188-.04.39-.095.606-.166.216-.071.43-.151.642-.24.212-.089.34-.145.387-.17l.072-.04.003-.003.014-.007.015-.007.014-.006.014-.007.003-.004.005-.003.004-.002.003-.004.014-.004.015-.003-.003.02-.004.02-.008.02-.007.02-.007.013-.007.014-.008.02a.434.434 0 00-.014.053c-.005.022-.05.11-.137.266a3.307 3.307 0 01-.325.473 2.4 2.4 0 01-.349.362 3.24 3.24 0 00-.206.173.611.611 0 01-.123.094l-.072.044-.014.006-.015.007-.003.004-.004.003-.004.002-.003.004-.015.007-.014.007-.003.004-.004.002-.005.003-.002.004-.003.004-.005.003-.004.002-.003.004h.072l.404-.08c.27-.053.527-.117.772-.193l.39-.12.043-.013.022-.007.014-.006.014-.007.015-.007.014-.006.03-.004.028-.003v.027l-.007.002-.007.004-.003.004-.005.003-.004.003-.003.004-.003.004-.004.002-.004.003-.003.004-.003.004-.004.003-.008.013-.007.013-.004.003-.183.226a1.91 1.91 0 01-.195.227c-.01.002-.023.016-.04.04a3.96 3.96 0 01-.307.297 7.092 7.092 0 01-.55.462c-.181.136-.273.303-.275.5a10.8 10.8 0 01-.033.67c-.02.248-.055.516-.108.805a8.985 8.985 0 01-.245.979c-.111.364-.246.72-.404 1.065a8.058 8.058 0 01-.498.933 9.096 9.096 0 01-.916 1.239c-.15.168-.338.358-.566.57-.229.21-.354.325-.375.346-.022.02-.116.092-.283.218a9.87 9.87 0 01-.534.381 6.25 6.25 0 01-.522.316c-.158.084-.35.18-.574.289a7.12 7.12 0 01-.724.303c-.26.094-.534.18-.823.26-.288.08-.567.142-.836.187-.27.044-.575.082-.917.113l-.512.046V18h-.938v-.007l-.122-.006a7.116 7.116 0 01-.202-.014 25.994 25.994 0 01-.599-.073 9.296 9.296 0 01-.815-.133 11.49 11.49 0 01-.88-.253 8.98 8.98 0 01-1-.377c-.276-.126-.45-.206-.52-.24a3.78 3.78 0 01-.233-.122l-.13-.074-.003-.004-.004-.002-.004-.003-.003-.004-.015-.007-.014-.006-.003-.004-.004-.003-.005-.003-.003-.004-.002-.004-.005-.002H4v-.027l.014.003.015.004.065.007c.043.004.16.01.353.02a7.051 7.051 0 002.078-.22c.308-.076.59-.165.848-.27.257-.104.44-.182.548-.234.108-.05.273-.144.494-.282l.332-.206.003-.004.004-.003.004-.003.003-.004.003-.004.004-.002.005-.003.002-.004.015-.004.014-.003.003-.013.005-.013.004-.003.003-.004-.116-.007a2.331 2.331 0 01-.563-.073 3.957 3.957 0 01-1.017-.413 2.558 2.558 0 01-.364-.244 6.099 6.099 0 01-.289-.271 2.735 2.735 0 01-.554-.794l-.12-.242-.007-.02-.007-.02-.005-.014-.002-.013.021.003.022.004.159.02c.105.013.271.017.497.013a4.17 4.17 0 00.47-.027c.086-.013.139-.022.158-.026l.029-.007.036-.007.036-.006.003-.004.004-.003.004-.003.003-.004-.029-.006-.028-.007-.03-.007-.028-.006-.029-.007a2.825 2.825 0 01-.101-.027 5.809 5.809 0 01-.39-.146 3.07 3.07 0 01-.504-.247 3.458 3.458 0 01-.358-.262 3.906 3.906 0 01-.371-.37 3.053 3.053 0 01-.599-1.099 2.877 2.877 0 01-.104-.553l-.026-.28.015.003.014.004.015.007.014.007.015.006.014.007.224.093c.149.062.334.116.555.16.221.044.353.069.397.073l.065.007h.13l-.003-.004-.005-.003-.004-.002-.003-.004-.003-.004-.004-.003-.004-.003-.003-.004-.015-.006-.014-.007-.003-.004-.004-.003-.005-.002-.003-.004-.014-.007-.014-.007-.003-.004-.124-.085a1.84 1.84 0 01-.249-.217 8.045 8.045 0 01-.26-.28 2.16 2.16 0 01-.23-.313 3.668 3.668 0 01-.214-.423 2.837 2.837 0 01-.219-1.461c.015-.12.043-.256.087-.406.043-.151.105-.311.187-.48l.123-.253.007-.02.007-.02.005-.003.002-.004.003-.004.005-.002.004.002.003.004.003.004.004.003.004.003.003.004.003.004.005.002.007.014.007.013.004.003.003.004.195.2c.13.133.284.281.462.446.178.164.276.25.295.255.02.007.044.028.073.062.028.032.125.111.288.235.164.125.378.269.642.433.265.164.558.326.88.486.322.16.669.304 1.039.433.37.129.63.213.779.253.15.04.404.091.765.153.36.063.632.103.815.12.183.018.308.028.375.03l.1.004-.002-.02-.004-.02-.03-.167a2.893 2.893 0 01-.028-.466A2.828 2.828 0 0112 7.964c.067-.173.133-.312.198-.416.065-.104.15-.223.256-.356.106-.133.243-.27.412-.413.168-.142.36-.268.577-.38a3.91 3.91 0 01.598-.252c.183-.058.337-.096.462-.114.125-.017.188-.028.188-.03z"
                      ></path>
                    </svg>
                    Tweet
                  </a>

                  <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" className="product--share--fb ml-15">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        fill="currentcolor"
                        d="M16.1 7.5V5h-2.4c-1.8 0-3.3 1.5-3.3 3.3v2.3H8v2.8h2.4V19h2.8v-5.6h2.4l.3-2.8h-2.7V8.4c0-.5.4-.9.9-.9h2z"
                      ></path>
                    </svg>
                    Facebook
                  </a>

                  <a href="#CopyLink" target="_blank" rel="noreferrer" className="product--share--black ml-15">
                    <svg className="mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        fill="currentcolor"
                        d="M13.697 9.879c1.412 1.412 1.369 3.718-.015 5.24l-.138.145-2.946 2.947c-1.518 1.518-3.929 1.61-5.386.153-1.412-1.412-1.37-3.718.015-5.241l.138-.145 2.062-2.062a1 1 0 011.492 1.327l-.077.087-2.063 2.062c-.76.76-.804 1.907-.153 2.558.619.618 1.684.61 2.44-.045l.117-.108 2.947-2.947c.722-.722.798-1.792.245-2.456l-.092-.101a1 1 0 011.414-1.414zm5.162-5.162c1.412 1.412 1.369 3.718-.015 5.24l-.138.146-2.063 2.062a1 1 0 01-1.492-1.327l.078-.087 2.063-2.063c.76-.76.804-1.906.153-2.557-.619-.619-1.684-.61-2.44.045l-.118.108-2.946 2.946c-.722.723-.798 1.793-.246 2.457l.093.1a1 1 0 01-1.414 1.415c-1.412-1.412-1.37-3.718.015-5.24l.138-.146 2.946-2.946c1.518-1.518 3.928-1.61 5.386-.153z"
                      ></path>
                    </svg>
                    Copy Link
                  </a>
                </div>
            </div>
          </div>

          <div className="row py-20">
            <div class="col-md-12">
              <p className="lead">
                <b>Description : </b> { product.description ? product.description : 'Holistic Sterilised is the best formula adapted to the needs of neutered cats, able to provide all the nutrients they need, day after day. Neutered cats usually tend to gain weight due to reduced motor activity: it is estimated that their fat needs decrease as much as 30% after sterilisation. Enriched with vitamins and minerals, formulated without food colouring or chemical preservatives, the Holistic Sterilised wet recipes naturally provide hydration and are ideal for weight control thanks to their monitored fat content.' }
              </p>
            </div>
          </div>

          <div className="row py-20 product--description-lists">
            <div className="col-md-3">
              <h4 className="almo-fs-20 mb-15 font-weight-bold">
                { product.analytical_constituents_title }
              </h4>

              <AnalyticalConstituents 
                constituents={product.analytical_constituents}
                energy_title={product.energy_title} 
                calories={product.calories}  />
            </div>
            <div className="col-md-6">
              <h4 className="almo-fs-20 mb-15 font-weight-bold">
                { product.composition_title }
              </h4>

              <p class="parse-list-items">
                { product.ingredients_title } <span className="d-inline-block" dangerouslySetInnerHTML={{__html: '<strong>' + product.composition + '</strong>'}} />
              </p>

              <p>
                Additives - Nutritional additives: vitamine D3 140 IU/kg vitamine E (3a700) 27 mg/kg, 
                vitamine B1 (3a821) 2,15 mg/kg, taurine (3a370) 202,9 mg/kg, copper 0,53 mg/kg (copper 
                sulphate pentahydrate), iodine 0,14 mg/kg (3b201), manganese 1,66 mg/kg (manganous sulphate 
                monohydrate), zinc 14,02 mg/kg (zinc sulphate, monohydrate). Technological additives: cassia gum 95 mg/kg.
              </p>
            </div>
            <div className="col-md-3">
              <h4 className="almo-fs-20 mb-15 font-weight-bold">
                Instructions
              </h4>

              <p class="font-weight-bold">
                Sugested daily serving
              </p>
              <p>
                Adult Cat 4 kg: 110 g wet food + 35 g dry food
              </p>

              <p class="font-weight-bold">
                Storage and shelf life
              </p>
              <p>
                Once opened, keep refrigerated and consume within 1 day.
              </p>
              <p>Shelf life 26 months.</p>
            </div>
          </div>

          <div className="row py-20">
            <div className="col-md-6">
              <p className="almo-fs-20">
                <b>60/40</b> Almo Nature nutrition philosophy
              </p>
            </div>
            <div className="col-md-6">
            <p className="almo-fs-20">
              <b>100%</b> of Almo Nature profit goes to nature
            </p>
            </div>
          </div>

          { product.recipes && product.recipes.length && 

          <div className="row py-20" id="MoreRecipes">
            <div className="col-md-12 text-center">
              <h2 class="almo-fs-32">More recipes</h2>
            </div>

            <div className="col-md-12">
              <ProductRecipes recipes={ product.recipes } />
            </div>
          </div>

          }
        </div>
      </Layout>
      )
}

export default almoProductsPage